import React, { useEffect, useState } from "react";
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./ReportBonus.css";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import M from "materialize-css";
import $ from "jquery";

import banner1 from "../logo.svg";
import { API_URL, numberWithCommas } from "../constant";

import jwt from "jsonwebtoken";
import HeaderBack from "../layout/HeaderBack";

import Select from "react-select";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import Stack from "@mui/material/Stack";
import { Backdrop, CircularProgress } from "@mui/material";

const ReportBonus = () => {
  const [token, setToken] = useLocalStorage("token", "");
  const [bonus, setBonus] = useState(undefined);
  const [period, setPeriod] = useState("");
  const [periodType, setPeriodType] = useState("");
  const [tokenData, setTokenData] = useState({});
  const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

  const notify = () => toast.error("Something went wrong!");

  async function downloadHandler() {
    setIsOpenBackdrop(true);
    if ($("#PeriodDate").val() != "" && periodType != "") {
      $("#btn-download").attr("disabled", "disabled");
      let response = await getBonusDetail(
        period.getFullYear(),
        period.getMonth() + 1,
        periodType.value
      );
      $("#btn-download").removeAttr("disabled");
      if (response) {
        if (response.status == 200) {
          $("#download").attr(
            "href",
            `https://shop.moorlife.id/${response.data}`
          );
          // $("#download").attr("href",`http://localhost:3001/${response.data}`);
          document.getElementById("download").click();
        } else {
          toast.error(response.message);
        }
      } else {
        notify();
      }
    } else {
      toast.error("All field is required!");
    }
    setIsOpenBackdrop(false); 
  }

  async function searchHandler() {
    setIsOpenBackdrop(true);
    if ($("#PeriodDate").val() != "" && periodType != "") {
      $("#btn-search").attr("disabled", "disabled");
      setBonus([]);
      let response = await getBonus(
        period.getFullYear(),
        period.getMonth() + 1,
        periodType.value
      );
      $("#btn-search").removeAttr("disabled");
      if (response) {
        response = JSON.parse(response);
        if (response.status == 200) {
          setBonus(response.data);
          console.log(response.data);
        } else {
          toast.error(response.message);
        }
      } else {
        notify();
      }
    } else {
      toast.error("All field is required!");
    }
    setIsOpenBackdrop(false);
  }

  function getBonusDetail(year, month, type) {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `${API_URL}api/bonusdetail/${year}/${month}/${type}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => {});
  }

  function getBonus(year, month, type) {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/bonus/${year}/${month}/${type}`, requestOptions)
      .then((response) => response.text())
      .catch((error) => {});
  }

  function updatePeriodType(val) {
    setPeriodType(val);
  }

  useEffect(async () => {
    setTokenData(jwt.decode(token));
    let el = document.querySelectorAll(".datepicker");
    let options = {
      format: "mm yyyy",
      onClose: async function () {
        // let d = this.date
        // if(d){
        //     let response = await getBonus(d.getFullYear(), d.getMonth() + 1);
        //     if(response){
        //         response = JSON.parse(response);
        //         if(response.status == 200){
        //             setBonus(response.data);
        //         }
        //     }else{
        //         notify();
        //     }
        // }
      },
    };
    var instance = M.Datepicker.init(el, options);
  }, []);

  return (
    <React.StrictMode>
      <Toaster position="bottom-center" />
      <HeaderBack title="Bonus Report" />
      <div className="">
        <div className="row" style={{ marginTop: "15px" }}>
          <div className="col s4">
            <h6 style={{ fontSize: "16pt" }}>Period</h6>
          </div>
          <div className="col s8">
            <Stack spacing={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  views={["year", "month"]}
                  label="Year and Month"
                  value={period}
                  onChange={async (newValue) => {
                    console.log(newValue);
                    // let d = newValue
                    // if(d){
                    //     let response = await getBonus(d.getFullYear(), d.getMonth() + 1);
                    //     if(response){
                    //         response = JSON.parse(response);
                    //         if(response.status == 200){
                    //             setBonus(response.data);
                    //         }
                    //         else{
                    //             setBonus([]);
                    //             toast.error(response.message)
                    //         }
                    //     }else{
                    //         notify();
                    //     }
                    // }
                    setPeriod(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </Stack>
            {/* <input type="text" className="datepicker" id="PeriodDate"/> */}
          </div>
        </div>
        <div className="row">
          <div className="col s4">
            <h6 style={{ fontSize: "16pt" }}>Type</h6>
          </div>
          <div className="col s8">
            <Select
              options={[
                { value: "Monthly", label: "Monthly" },
                { value: "Weekly", label: "Weekly" },
              ]}
              value={periodType}
              onChange={updatePeriodType}
              placeholder={`Period Type`}
              style={{}}
            ></Select>
          </div>
        </div>
        <div className="row">
          <div className="col s6">
            <a
              href="#"
              className="btn"
              id="btn-search"
              onClick={() => searchHandler()}
            >
              <i className="material-icons">search</i> <span>Search</span>
            </a>
          </div>
          <div className="col s6">
            <a
              href="#"
              className="btn"
              id="btn-download"
              onClick={() => downloadHandler()}
            >
              <i className="material-icons">file_download</i>{" "}
              <span>Download</span>
            </a>
            <a
              style={{ display: "none" }}
              download
              id="download"
              target="_blank"
            >
              redirect
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th colSpan={2} style={{textAlign:"right"}}>Total</th>
                </tr>
              </thead>
              {bonus ? (
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Personal Recruit Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.PersonalRecruitBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Unit Leader Recruit Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.UnitLeaderRecruitBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Baby Leader Recruit Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.BabyLeaderRecruitBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Unit Master Recruit Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.UnitMasterRecruitBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Baby Master Recruit Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.BabyMasterRecruitBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Personal Sales Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.PersonalSalesBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Unit Sales Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.UnitSalesBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Unit Leader Sales Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.UnitLeaderSalesBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Leadership Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.LeadershipBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Unit Master Sales Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.UnitMasterSalesBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Mastership Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.MastershipBonus)}
                    </td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Performance Bonus</td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(bonus.PerformanceBonus)}
                    </td>
                  </tr>
                  {tokenData.MemberLevel == 4 ? (
                    <tr>
                      <td>13</td>
                      <td>CEO Recruit Bonus</td>
                    <td>Rp.</td>
                      <td className="right">
                        {numberWithCommas(bonus.CEORekrutBonus)}
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                  {tokenData.MemberLevel == 4 ? (
                    <tr>
                      <td>14</td>
                      <td>CEO Sales Bonus</td>
                    <td>Rp.</td>
                      <td className="right">
                        {numberWithCommas(bonus.CEOSalesBonus)}
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                  <tr>
                    <td colSpan={2}>
                      <b>Total bonus yang diperoleh</b>
                    </td>
                    <td>Rp.</td>
                    <td className="right">
                      {numberWithCommas(
                        bonus.Total +
                          (tokenData.MemberLevel == 4
                            ? bonus.CEORekrutBonus + bonus.CEOSalesBonus
                            : 0)
                      )}
                    </td>
                  </tr>
                </tbody>
              ) : (
                <></>
              )}
            </table>
          </div>
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpenBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.StrictMode>
  );
};

export default ReportBonus;
